import { AssertionException } from '../../utils/log';
import { Guid } from '../model/guid';
import { HistoryItem } from '../reducers/currentSequencedFlowPositionReducer';
import { GetItemById, getItemByIdSelector } from '../reducers/items/itemsSelectors';
import { isSection, isSequencedFlowItem, isSequencedFlowStep } from '@ael/core-api';
import { List } from 'immutable';
import * as memoize from 'memoizee';
import { createSelector } from 'reselect';

const getSequencedFlowStructure = (getItemById: GetItemById, itemId: Guid): List<HistoryItem> => {
  const item = getItemById(itemId);

  if (isSequencedFlowItem(item) || isSection(item)) {
    const childItems = isSection(item) ? item.children : item.contentItems;
    const items = childItems.reduce((acc: List<HistoryItem>, itemId: string) => {
      const contentItem = getItemById(itemId);
      if (isSequencedFlowStep(contentItem)) {
        return acc.push({ contentItemId: contentItem.id, sectionId: isSection(item) ? item.id : null });
      }
      if (isSection(contentItem)) {
        return acc.concat(
          getSequencedFlowStructure(getItemById, contentItem.id).splice(0, 0, {
            contentItemId: contentItem.id,
            sectionId: isSection(item) ? item.id : null,
          })
        );
      }
      throw AssertionException('Invalid item type detected. Item type can only be  section or linear flow step.');
    }, List<HistoryItem>());

    return items.toList();
  }
  throw AssertionException('Not a linear flow item or section.');
};

// Returns a linear flow history structure in a correct order.
export const getSequencedFlowStructureSelector = createSelector(getItemByIdSelector, (getItem) =>
  memoize((itemId: Guid) => getSequencedFlowStructure(getItem, itemId))
);
